// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Layout_Wrapper__2qr5N","selectType":"Layout_selectType__Gco_I"};